import { initSwiper } from "./Init";

_gg.domReady(initSwiper);
